import { Icon } from "../../../../core/icon";
import { PALETTE_PANE_ID } from "../ui-panes/PalettePane";
import { createHexFromCoords } from "./_common";
import { PickingInfoPoint } from "../../math/PickingInfoPoint";
import { OffsetPoint } from "../../math/OffsetPoint";
import { Set } from "immutable";
export const DrawRectToolID = 'drawRect';
const changeLabel = 'Erase Hexes';
export const createDrawRectTool = (props) => {
    const [_, addToHexModel, removeFromHexModel] = props.hexMapModelContext;
    const { editorState, interactionState } = props.viewStateContext;
    const { highlightedHexes, setHighlightedHexes } = props.highlightLayerContext;
    const { pigment } = editorState;
    const onDrag = (info) => {
        if (!info.coordinate || !editorState.priorDragStartEvent?.info.coordinate)
            return;
        const corner1 = PickingInfoPoint.toPixelPoint(editorState.priorDragStartEvent.info.coordinate);
        const corner2 = PickingInfoPoint.toPixelPoint(info.coordinate);
        return setHighlightedHexes(OffsetPoint.pointsWithinPixelRect(corner1, corner2));
    };
    const onHover = (info, event) => {
        if (interactionState?.isDragging)
            return;
        if (!info.coordinate)
            return setHighlightedHexes(Set());
        if (editorState.priorGestureEvent?.info.coordinate && event.srcEvent.shiftKey) {
            const corner1 = PickingInfoPoint.toPixelPoint(editorState.priorGestureEvent.info.coordinate);
            const corner2 = PickingInfoPoint.toPixelPoint(info.coordinate);
            return setHighlightedHexes(OffsetPoint.pointsWithinPixelRect(corner1, corner2));
        }
        const offsetPoint = PickingInfoPoint.toRoundedOffsetPoint(info.coordinate);
        return setHighlightedHexes(Set.of(offsetPoint));
    };
    const onClick = (info) => {
        const _createHexFromCoords = createHexFromCoords.bind(null, pigment.color);
        if (!info.coordinate)
            return;
        addToHexModel('Draw Hex Rectangle', highlightedHexes.map(_createHexFromCoords));
    };
    return {
        id: DrawRectToolID,
        label: 'Draw Rectangle',
        icon: Icon.TOOL_DRAW_RECT,
        disablePan: true,
        usesToolOptions: {
            [PALETTE_PANE_ID]: true,
        },
        onClick,
        onDrag,
        onDragEnd: onClick,
        onHover,
    };
};
createDrawRectTool.toolID = DrawRectToolID;
//# sourceMappingURL=drawRectTool.js.map